import styled from '@emotion/styled';
import { FireworkLogoAndText } from '@core/assets/FireworkLogoAndText';
export const BrandLink = styled.a `
  text-decoration: none;
`;
export const Container = styled.div `
  position: absolute;
  bottom: 18px;
  align-items: center;
  display: flex;
  flex-direction: row;
  font-size: 18.3px;
  font-weight: normal;
  align-items: center;
  justify-content: center;
  padding: 0 0 0 2px;
  width: 100%;
`;
export const BrandLogo = styled(FireworkLogoAndText) `
  display: inline !important;
  height: 24px !important;
  margin: 0 5px 0 0 !important;
  padding: 0 !important;
  width: 115px !important;
`;
